<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>EVENTS</div>
				<h2 waHeading="l" waText>Server-Driven Event Handling</h2>
				<p waBody="m" waColorText="quiet" waText>Browser events fire Java handlers. Responses update the DOM.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>50+ Event Adapters</h3>
							<p waBody="m" waColorText="quiet" waText>OnClickAdapter, OnChangeAdapter, OnSubmitAdapter, OnDragAdapter, OnKeyDownAdapter, OnMouseEnterAdapter &mdash; each backed by a ServiceLoader SPI. Events must be named classes &#40;no lambdas&#41; for serialization and discovery.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>AJAX Pipeline</h3>
							<p waBody="m" waColorText="quiet" waText>AjaxCall carries the event payload from browser to server. AjaxResponse returns DOM updates, component replacements, and script execution. The pipeline is fully reactive on Vert.x.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Feature System</h3>
							<p waBody="m" waColorText="quiet" waText>Feature&lt;O,J&gt; wraps a JavaScript library with typed options, CSS/JS references, and automatic dependency ordering. Features must be named classes for deduplication.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Call Interceptors</h3>
							<p waBody="m" waColorText="quiet" waText>SiteCallIntercepter, AjaxCallIntercepter, DataCallIntercepter &mdash; CRTP-based, sort-ordered, pluggable request processing for cross-cutting concerns like auth, logging, and metrics.</p>
						</div>
					</wa-card>
				</div>
			</div>
		</div>
	</div>
</div>